<template>
  <v-container class="perguntas-frequentes">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <PageTitle
        main="TcWeb"
        icon="mdi-pencil-box-outline"
        sub="Perguntas frequêntes"
        home="/home"
      />
      <page-cad />
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import PageCad from './../components/perguntas'
export default {
  name: 'PerguntasFrequentes',
  components: { PageTitle, PageCad }
}
</script>
